import React from 'react'
import FormatDate from '../date/FormatDate'
import { Typography } from '@mui/material'

const TextLog = ({ updatedBy, updatedAt }) => {
  return (
    <div>
      <Typography variant='body2' color='textSecondary'>
        {updatedAt?.code || updatedBy?.fullName || updatedBy?.code || 'System'} on
      </Typography>
      <Typography component='span' variant='body2'><FormatDate date={updatedAt}  pattern='dd/MMM/yyyy HH:mm a' /></Typography>
    </div>
  )
}

export default TextLog